var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMickeyears(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WDW-Icons-ExMagicHrs 1",
    clipPath: "url(#clip0_142_3811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M16.3885 1.6112C14.6568 0.327127 12.3801 0.501965 11.2708 1.98108C10.8426 2.56463 10.6678 3.24574 10.7067 3.94627C10.1814 3.80984 9.63628 3.73218 9.09152 3.73218C8.48814 3.73218 7.92401 3.80984 7.37932 3.96568C7.41815 3.26519 7.24294 2.56463 6.81477 1.98108C5.7055 0.501965 3.42913 0.327127 1.71646 1.6112C-0.0151808 2.89527 -0.521051 5.13323 0.588211 6.61193C1.17177 7.39061 2.06694 7.77949 3.0398 7.81831C2.74805 8.57753 2.5728 9.39462 2.5728 10.2315C2.5728 12.119 3.39029 13.8118 4.67434 14.9988L4.65492 15.0181C5.49184 15.7575 6.523 16.3221 7.6711 16.575C7.82648 16.6139 7.96287 16.6333 8.09926 16.6527C8.19637 16.6721 8.27406 16.6915 8.37162 16.711C8.60512 16.7304 8.83861 16.7502 9.09152 16.7502C12.6718 16.7502 15.5909 13.8312 15.5909 10.2315C15.5909 9.37516 15.4156 8.57753 15.1239 7.81831C16.0579 7.76003 16.9332 7.37115 17.4978 6.61193C18.6066 5.13323 18.1007 2.89527 16.3885 1.6112ZM9.05273 15.2128C6.36716 15.2128 4.20735 13.0336 4.20735 10.3675C4.20735 7.70179 6.36716 5.52253 9.05273 5.52253C11.7184 5.52253 13.8782 7.70179 13.8782 10.3675C13.8782 13.0336 11.7184 15.2128 9.05273 15.2128ZM11.9907 12.0607C11.8742 12.2549 11.6601 12.3719 11.446 12.3719C11.3489 12.3719 11.232 12.3525 11.1349 12.2942L8.74109 10.9126C8.54684 10.7956 8.42986 10.5815 8.42986 10.3675V7.17649C8.42986 6.84547 8.70222 6.55365 9.05273 6.55365C9.38333 6.55365 9.65566 6.84547 9.65566 7.17649V10.0174L11.7572 11.2238C12.0494 11.3796 12.166 11.7685 11.9907 12.0607Z",
    fill: "#06406F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_142_3811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0866,
    height: 16,
    fill: "white",
    transform: "translate(0 0.750122)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMickeyears);
export default __webpack_public_path__ + "static/media/mickeyears.c2f87248.svg";
export { ForwardRef as ReactComponent };